/**
 * Returns { primary, secondary } display strings for a product.
 * primary  → proBrand (bold label)
 * secondary → compact joined string of non-empty: proVintage, proFanciful, proVersion, proVarietal, proAppellation
 */
export function formatProductDisplay(product) {
  const primary = product.proBrand || '—';
  const secondary = [
    product.proVintage,
    product.proFanciful,
    product.proVersion,
    product.proVarietal,
    product.proAppellation,
  ].filter(Boolean).join(' · ');
  return { primary, secondary };
}
